// locale mixin
import dateFormat from 'date-format';
export default {
    data: function() {
        return {
            globalDateFormat: 'DD-MM-YYYY',
            datepickerFormat: 'dd-mm-yyyy',
        }
    },
    methods: {
        lang: function(key) {
            let text = LANGUAGE[key];
            if (text && text.length) {
                if (text === '&/-*') {  //strange text to represent empty to deal with has Polish tooltip but no english tooltip
                    return '';
                }
                return LANGUAGE[key];
            } else {
                return '__' + key; // From UI it will be obvious that there's no language mapping for the key
            }
        },
        textLangKeyValueThenEmpty: function(key, text=null) {
            let hasLangKey = LANGUAGE.hasOwnProperty(key);
            return text ? text : (hasLangKey ? LANGUAGE[key] : '');
        },
        formatDate: function(dateStr) {
            return dateFormat('dd-MM-yyyy', new Date(Date.parse(dateStr)));
        },
        formatDateToISO: function (dateStr) {
            const formatted = dateFormat('dd-MM-yyyy', new Date(Date.parse(dateStr)));//  moment(dateStr, this.globalDateFormat).format('DD-MM-YYYY');
            return formatted;
        },
        currency: function (amount) {
            if (!isNaN(amount)) {
                const formatted = Number(amount).toFixed(2);
                return `USD \$${formatted}`;
            } else {
                return 'NaN';
            }
        },
    }
}
